module.exports = __webpack_public_path__ + "img/sh-img5.5ccda1a9.png";